import Vue from "vue";
import Index from "./components/Index";
import "./assets/scss/main.scss";

new Vue({ components: { index: Index } }).$mount("#app");

(function() {
  var burger = document.querySelector(".navbar-burger");
  var menu = document.querySelector(".navbar-menu");
  burger.addEventListener("click", function() {
    burger.classList.toggle("is-active");
    menu.classList.toggle("is-active");
  });
})();
